import { isLocalEnv } from '../../configs/settings/environment'
import {
  CLEAN_PUBLIC_USER,
  GET_UNIQUE_KEY_TOKEN,
  GET_UNIQUE_KEY_TOKEN_ERROR,
  GET_UNIQUE_KEY_USER,
  GET_UNIQUE_KEY_USER_ERROR,
  GET_UNIQUE_KEY_USER_SUCCESS
} from './UniquePassAuth.actions'

const uniquePassAuthState = {
  error: false,
  loading: false,
  publicUserDni: isLocalEnv ? '88.888.888-8' : '',
  publicUserName: isLocalEnv ? 'Usuario Local' : ''
}

/**
 * The unique pass auth's reducer.
 */
const uniquePassAuthReducer = (state = uniquePassAuthState, { payload, type }) => {
  switch (type) {
    case CLEAN_PUBLIC_USER: {
      return {
        ...state,
        publicUserDni: '',
        publicUserName: ''
      }
    }
    case GET_UNIQUE_KEY_TOKEN:
    case GET_UNIQUE_KEY_USER: {
      return {
        ...state,
        error: false,
        loading: true
      }
    }
    case GET_UNIQUE_KEY_TOKEN_ERROR:
    case GET_UNIQUE_KEY_USER_ERROR: {
      return {
        ...state,
        error: true,
        loading: false
      }
    }
    case GET_UNIQUE_KEY_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        publicUserDni: payload.publicUserDni,
        publicUserName: payload.publicUserName
      }
    }
    default: {
      return state
    }
  }
}

export default uniquePassAuthReducer
